import React from 'react';
import './Pokerwatch_new.css';
import Loading from '../Loading.js';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
let imgUrl = "/images/handReplay/";
import { createVirtualPageLoad, closeVirtualPage, saveActivity } from '../../common/commonService';
import moment from 'moment';
import { apiService } from '../../common/apiCallService.js';
import { baseUrl } from '../../common/config.js';
import '../../../node_modules/mygame-components/src/DatePicker/input-moment.css';
import '../../../node_modules/mygame-components/src/DatePicker/InputDatePickerPopup.css';
import Dialog from 'material-ui/Dialog';
import DownloadHandHistory from '../../components/DownloadHandHistory/DownloadHandHistory';
import MediaQuery from 'react-responsive';
import PokerwatchTeamBody from './Pokerwatch-team-body';
import PokerwatchPlayerBody from './Pokerwatch-player-body'
import { withRouter } from 'react-router-dom';
import { FileUploadComponent, FileUploadDetails } from './pokerwatchCommonComponents';
class PokerWatchTeam extends React.Component {
  constructor(props, context) {
    super(props, context);
    const userRole = JSON.parse(localStorage.getItem('userRole'));
    this.state = {
      currentSubTeam: '',
      pokerwatchTeamBody: {},
      dialogContent: { 'isError': false },
      filterEnable: false,
      menuEnable: false,
      userLoggedInRole: userRole,
      bussinessOwnerStatus: userRole.indexOf('SYS_ADMIN') === -1 && userRole.indexOf('BUSINESS_OWNER') !== -1 ? false : true,
      isCoach: userRole.indexOf('SYS_ADMIN') === -1 && userRole.indexOf('BUSINESS_OWNER') === -1 && userRole.indexOf('COACH') !== -1 ? true : false,
      teamData: userRole.indexOf('SYS_ADMIN') !== -1 || userRole.indexOf('BUSINESS_OWNER') !== -1  ? JSON.parse(localStorage.getItem('teamData')) : '',
      playerData: null,
      open: false,
      shift: 'Select',
      value: '',
      shiftValue: 'Select',
      timeValue: 'Select',
      timeZonevalue: 'Select',
      offset: 0,
      selectedFromDate: moment().subtract(2, 'days'),
      selectedToDate: moment(),
      fromTimeZoneDate: "",
      toTimeZoneDate: "",
      dateError: "",
      error: "",
      showFromDatePicker: false,
      showToDatePicker: false,
      isOpen: false,
      isToOpen: false,
      loginRedirect: false,
      loading: false,
      teamTableStatus: true,
      showForm: false,
      data: [],
      downloadFrom: null,
      selectTo: null,
      selectTimeTo: null,
      playerName: '',
      orderBy: 'asc',
      sortOn: '',
      startIndex: 0,
      max: 20,
      inputRequest: {},
      createPlayerModal: false,
      newAccountName: null,
      newPlyName: '',
      newPlyNickName: '',
      newPlySurname: '',
      playerErrorMsg: '',
      deletePlyrData: [],
      deletePlayerModal: false,
      downloadModal: false,
      title: 'Poker Watch Team',
      roleValue: 'player',
      roleChangedModal: false,
      fileListModal: false,
      uploadedFile: null,
      uploadedFileList: null,
      nextLoading: true,
      uploadingFileList: [],
      fileDetailsList: [],
      uploading: false,
      maxSelectFileStatus: true,
      memeTypeStatus: true,
      statusButtonStatus: false,
      statsUpdateModal: false,
      playerActivity: 1,
      gameType: 'cash',
      onOff: '',
      oldSort: '',
      oldGameType: '',
      oldPlayerAct: 3,
      playerNameData: [],
      query: '',
      gameDetails: false,
      moreEnable: false,
      subMenuEnable: false,
      playerNameDataByTeam: [],
      teamFeedSettings: false,
      fileUploadErrorMessage: '',
      playerMenuEnable: false
    };
    this.getPlayerDetailsByTeamNameAndNameWithDetails = this.getPlayerDetailsByTeamNameAndNameWithDetails.bind(this);
    this.searchPlayerDetailsOnEnter = this.searchPlayerDetailsOnEnter.bind(this);
    this.routeChange = this.routeChange.bind(this);
    //  console.log('history listen-------------', window.location.href)

  }

  callTeamList = (game, startDate, endDate, isRequiredToCallPlayerApi, subTeamName) => {
    this.setState({
      loading: true
    })
    apiService(baseUrl + '/pokerWatch/getTeamList',
      {
        name: (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '',
        orderBy: this.state.orderBy,
        sortOn: 'lastHandPlayer',
        startDate: startDate.format("YYYY-MM-DD HH:mm:ss"),
        endDate: endDate.format("YYYY-MM-DD HH:mm:ss"),
        gameType: game,
        offset: this.state.offset,
        subTeam: subTeamName ? subTeamName : 'all',
      }
      ,
      (data) => {
        const { pokerwatchTeamBody } = this.state
        pokerwatchTeamBody['teamData'] = data[0].teamList;
        // localStorage.setItem('teamData', JSON.stringify(data[0].teamList));
        //  pokerwatchTeamBody['filterEnable'] = false;
        // pokerwatchTeamBody['subTeam'] = data[0].subTeam;
        let currentSubTeamObj = {};
        let currentSubTeam = '';
        //  console.log('isCoach', this.state.isCoach);
        if (this.state.isCoach || (subTeamName && data[0].subTeam && data[0].subTeam.length == 1)) {
          currentSubTeamObj = data[0].subTeam[0];
          currentSubTeam = data[0].subTeam[0].teamName
        } else {
          currentSubTeam = this.state.pokerwatchTeamBody['currentSubTeam'] && subTeamName && subTeamName !== 'all' ? this.state.pokerwatchTeamBody['currentSubTeam'] : '';
          currentSubTeamObj = this.state.pokerwatchTeamBody['currentSubTeamObj'] && subTeamName && subTeamName !== 'all' ? this.state.pokerwatchTeamBody['currentSubTeamObj'] : {};
        }
        pokerwatchTeamBody['currentSubTeam'] = currentSubTeam;
        pokerwatchTeamBody['startIndex'] = 0;
        pokerwatchTeamBody['currentSubTeamObj'] = currentSubTeamObj;
        this.setState({
          //  filterEnable: false,
          currentSubTeam: currentSubTeam,
          pokerwatchTeamBody,
          teamData: data[0].teamList,
          loading: false,
        })

        if (isRequiredToCallPlayerApi) {
          let playerArray = []
          if (window.location.hash.trim().length > 0) {
            playerArray = [window.location.hash.replace("#", '')]
          }
          else {
            playerArray = this.state.playerName && this.state.playerName !== '' ? [this.state.playerName] : []
          }

          this.callApi(currentSubTeam, playerArray, 0,
            this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
            this.state.gameType, this.state.playerActivity, this.state.sortOn);
          this.getCallSubTeamList();
        }
      }, (err) => {
        console.log('err', err);
        this.setState({
          loading: false
        })
      })

  }
  onVisibilityChange = (isVisible, type) => {
    if (type && type === "player") {
      const { pokerwatchTeamBody } = this.state
      if (isVisible && pokerwatchTeamBody['isPlayerStatsAvailable']) {
        this.callNext('player')
      }
    }
    else {
      const { pokerwatchTeamBody } = this.state
      if (isVisible && pokerwatchTeamBody['isNextAvailable']) {
        this.callNext('team')
      }
    }

  }
  updatePosition = (status) => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['position'] = status;
    this.setState({
      pokerwatchTeamBody
    })
  }
  callApi = (currentSubTeam, player, startIndex, max, orderBy, selectedFromDate, selectedToDate, gameType, playerActivity, sortOnField, isCallNext) => {
    const { pokerwatchTeamBody, dialogContent } = this.state;
    this.setState({
      loading: true
    })
    let inputRequest = {
      teamName: pokerwatchTeamBody['teamData'] && pokerwatchTeamBody['teamData'].teamName ? pokerwatchTeamBody['teamData'].teamName : (pokerwatchTeamBody['teamData'] && pokerwatchTeamBody['teamData'].name ? pokerwatchTeamBody['teamData'].name : ''),
      subTeamName: this.state.currentSubTeam ? this.state.currentSubTeam : currentSubTeam,
      startDate: selectedFromDate.format("YYYY-MM-DD HH:mm:ss"),
      endDate: selectedToDate.format("YYYY-MM-DD HH:mm:ss"),
      startIndex: startIndex,
      max: max,
      orderBy: orderBy,
      offset: this.state.offset,
      subTeamName: this.state.currentSubTeam
    }
    if (player !== undefined && player !== null) {
      inputRequest['playerName'] = player;
    }
    if (sortOnField && sortOnField !== '') {
      inputRequest['sortOn'] = sortOnField;
    }
    if (gameType && gameType !== '') {
      inputRequest['gameType'] = gameType;
    }
    if (playerActivity && playerActivity !== '') {
      inputRequest['plyAct'] = playerActivity;
    }
    apiService(baseUrl + '/pokerWatch/getPlayersListByTeam',
      inputRequest,
      (data) => {
        let playerName = player ? player[0] : '';
        let refreshedPlayerData;

        pokerwatchTeamBody['selectedData'] = isCallNext ? pokerwatchTeamBody['selectedData'] : [];

        if (!(startIndex !== 0 && data.length == 0)) {
          let teamTableData = data.map((item, key) => {
            item['statsVisibleIcon'] = item.statsVisible ? <i className="fa fa-chart-bar chart-bar-icon"></i> : '';
            if (playerName !== '' && item['playerName'] === playerName) {
              refreshedPlayerData = item;
            }
            return item
          })
          if (!isCallNext) {
            pokerwatchTeamBody['isNextAvailable'] = true;
          }
          if (teamTableData.length < this.state.max) {
            pokerwatchTeamBody['isNextAvailable'] = false;
          }
          pokerwatchTeamBody['teamTableData'] = isCallNext && pokerwatchTeamBody['teamTableData'] ? pokerwatchTeamBody['teamTableData'].concat(teamTableData) : teamTableData
          pokerwatchTeamBody['players'] = [];
          dialogContent['isDialogOpen'] = false;
          pokerwatchTeamBody['dialogContent'] = dialogContent;
          if (player && player.length === 1 && playerName !== '' && refreshedPlayerData && refreshedPlayerData.playerName) {
            pokerwatchTeamBody['playerData'] = refreshedPlayerData
            this.stateChange('', pokerwatchTeamBody['playerData']);
          }
          this.setState({
            pokerwatchTeamBody,
            loading: false,
            data: data,
            nextLoading: data.length < this.state.max ? false : true,
          })

        }
        else {
          pokerwatchTeamBody['isNextAvailable'] = false;
          this.setState({
            pokerwatchTeamBody,
            loading: false
          })
        }

      }, (err) => {
        pokerwatchTeamBody['teamTableData'] = [];
        pokerwatchTeamBody['isNextAvailable'] = false;
        console.log('Error', err);
        this.setState({
          pokerwatchTeamBody,
          loading: false,
          error: "No Data Found"
        })
      })
  }
  componentDidMount() {
    createVirtualPageLoad("/pokerwatchteam");
    let selectedFromDate = moment().subtract(2, 'days');
    let selectedToDate = moment();
    let fromDate = selectedFromDate.format("DD/MM/YYYY - hh:mmA");
    let toDate = selectedToDate.format("DD/MM/YYYY - hh:mmA");
    let filterStatusObj = [
      {
        "key": "Game Type",
        "value": "Cash Games",
        "defaultValue": "Cash Games",
        "visible": false,
        "passedValue": "cash",
        "action": this.handleGameType,
        "showView": true,
      },
      {
        "key": "Teams",
        "value": "Show All Team",
        "defaultValue": "Show All Team",
        "visible": false,
        "passedValue": "all",
        "showView": true,
        "action": this.switchTeam
      },
      { "key": "From", "value": fromDate, "defaultValue": fromDate, "visible": false, "action": this.clearFromDateApi, "passedValue": selectedFromDate, "showView": true, },
      { "key": "To", "value": toDate, "defaultValue": toDate, "visible": false, "action": this.clearToDateApi, "passedValue": selectedToDate, "showView": true, },
      { "key": "Player Activity", "value": "Played", "defaultValue": "All", "visible": true, "action": this.handlePlayerActivity, "passedValue": "2", "showView": true },
    ]
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['teamData'] = this.state.teamData;
    pokerwatchTeamBody['subTeam'] = [];
    pokerwatchTeamBody['currentSubTeam'] = '',
      pokerwatchTeamBody['NumberFormatter'] = this.NumberFormatter;
    pokerwatchTeamBody['enableComponent'] = this.enableComponent;
    pokerwatchTeamBody['openFileListModal'] = this.openFileListModal;
    pokerwatchTeamBody['handlePlayerSearch'] = this.getPlayerDetailsByName;
    pokerwatchTeamBody['handleReplayer'] = this.handleReplayer;
    pokerwatchTeamBody['searchPlayerDetailsOnEnter'] = this.searchPlayerDetailsOnEnter;
    pokerwatchTeamBody['deletePlyrData'] = this.state.deletePlyrData;
    pokerwatchTeamBody['filterEnable'] = this.state.filterEnable;
    pokerwatchTeamBody['statsDetail'] = {};
    pokerwatchTeamBody['teamTableData'] = this.state.data;
    pokerwatchTeamBody['filterGrid'] = {};
    pokerwatchTeamBody['isSubTeamAvailable'] = false;
    pokerwatchTeamBody['handleGameType'] = this.handleGameType;
    pokerwatchTeamBody['gameType'] = this.state.gameType;
    pokerwatchTeamBody['downloadFrom'] = this.state.downloadFrom;
    pokerwatchTeamBody['selectedFromDate'] = this.state.selectedFromDate;
    pokerwatchTeamBody['selectedToDate'] = this.state.selectedToDate;
    pokerwatchTeamBody['showFromDatePicker'] = this.state.showFromDatePicker;
    pokerwatchTeamBody['showToDatePicker'] = this.state.showToDatePicker;
    pokerwatchTeamBody['dateError'] = this.state.dateError;
    pokerwatchTeamBody['selectTo'] = this.state.selectTo;
    pokerwatchTeamBody['handleSave'] = this.handleSave;
    pokerwatchTeamBody['handlePlayerActivity'] = this.handlePlayerActivity;
    pokerwatchTeamBody['playerActivity'] = this.state.playerActivity;
    pokerwatchTeamBody['playerNameDataByTeam'] = this.state.playerNameDataByTeam;
    pokerwatchTeamBody['playerNameData'] = [];
    pokerwatchTeamBody['handleSearch'] = this.getPlayerDetailsByTeamNameAndNameWithDetails;
    pokerwatchTeamBody['getPlayerDetailsByTeamNameAndName'] = this.getPlayerDetailsByTeamNameAndName;
    pokerwatchTeamBody['stateChange'] = this.stateChange;
    pokerwatchTeamBody['addPlayerToList'] = this.addPlayerToList;
    pokerwatchTeamBody['addPlayerToTeam'] = this.addPlayerToTeam;
    pokerwatchTeamBody['openDialogBox'] = this.openDialogBox;
    pokerwatchTeamBody['cancelDialog'] = this.cancelDialog;
    pokerwatchTeamBody['errorOBj'] = {};
    pokerwatchTeamBody['updateObject'] = this.updateObject
    pokerwatchTeamBody['creatTeamObj'] = {}
    pokerwatchTeamBody['action'] = {};
    pokerwatchTeamBody['coachDetails'] = [];
    pokerwatchTeamBody['verifyUnique'] = this.verifyUnique;
    pokerwatchTeamBody['createTeam'] = this.createSubTeam;
    pokerwatchTeamBody['handleInputChange'] = this.verifyCoachByNameOrUserName;
    pokerwatchTeamBody['onFilter'] = this.filterPlayerNames;
    pokerwatchTeamBody['handleSelectPlayer'] = this.handleSelectPlayer;
    pokerwatchTeamBody['selectedPlayers'] = [];
    pokerwatchTeamBody['playerData'] = this.state.playerData;
    pokerwatchTeamBody['playerStats'] = [];
    pokerwatchTeamBody['handleChange'] = this.handleChange;
    pokerwatchTeamBody['callDateApi'] = this.callDateApi;
    pokerwatchTeamBody['reportCard'] = this.reportCard;
    pokerwatchTeamBody['deletePlayer'] = this.deletePlayer;
    pokerwatchTeamBody['handleCheck'] = this.handleCheck;
    pokerwatchTeamBody['handleCheckbox'] = this.handleCheckbox;
    pokerwatchTeamBody['switchTeam'] = this.switchTeam;
    pokerwatchTeamBody['handleAssignTeam'] = this.handleAssignTeam;
    pokerwatchTeamBody['bussinessOwnerStatus'] = this.state.bussinessOwnerStatus;
    pokerwatchTeamBody['handleSort'] = this.sorting;
    pokerwatchTeamBody['handlePlayerSort'] = this.playerSort;
    pokerwatchTeamBody['sortOrder'] = this.state.orderBy;
    pokerwatchTeamBody['isCoach'] = this.state.isCoach;
    pokerwatchTeamBody['routeChange'] = this.routeChange;
    pokerwatchTeamBody['handleTeamAndPlayer'] = this.handleTeamAndPlayer;
    pokerwatchTeamBody['handleShowPlayers'] = this.handleShowPlayers;
    pokerwatchTeamBody['callNext'] = this.callNext;
    pokerwatchTeamBody['startIndex'] = this.state.startIndex;
    pokerwatchTeamBody['isNextAvailable'] = true;
    pokerwatchTeamBody['isPlayerStatsAvailable'] = true;
    pokerwatchTeamBody['onVisibilityChange'] = this.onVisibilityChange;
    pokerwatchTeamBody['playerStartIndex'] = this.state.startIndex;
    pokerwatchTeamBody['activeComponentName'] = '';
    pokerwatchTeamBody['updatePosition'] = this.updatePosition;
    pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
    this.setState({
      pokerwatchTeamBody
    });

    this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true);

    this.props.history.listen((location, action) => {
      this.handleRouteChange()
    });
  }
  clearFromDateApi = (event) => {
    this.handleChange(moment().subtract(2, 'days'), "selectedFromDate");
    this.handleSave("downloadFrom", "showFromDatePicker", "cleared");
    this.clearTimeFilter(moment().subtract(2, 'days'), 'From');
  }
  clearToDateApi = (event) => {
    this.handleChange(moment(), "selectedToDate")
    this.handleSave("selectTo", "showToDatePicker", "cleared");
    this.clearTimeFilter(moment(), 'To');
  }
  clearTimeFilter = (time, type, ) => {
    const { pokerwatchTeamBody } = this.state;
    let { filterStatusObj } = pokerwatchTeamBody;
    filterStatusObj = filterStatusObj.map((item, key) => {
      if (item.key === type) {
        item.value = time.format("DD/MM/YYYY - hh:mmA");
        item.defaultValue = time.format("DD/MM/YYYY - hh:mmA");
        item.visible = false;
        item.passedValue = time;
      }
      return item;
    })
    pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
    pokerwatchTeamBody[type === 'From' ? 'downloadFrom' : 'selectTo'] = time;
    this.setState({
      pokerwatchTeamBody
    })
  }
  handleShowPlayers = () => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['showStatus'] = pokerwatchTeamBody['showStatus'] ? !pokerwatchTeamBody['showStatus'] : true
    this.setState({
      pokerwatchTeamBody
    })
  }
  handleTeamAndPlayer = () => {
    localStorage.setItem('teamTableStatus', this.state.teamTableStatus)
  }
  handleRouteChange = () => {
    if (window.location.hash == '' && !this.state.teamTableStatus) {
      this.stateChange();
    }
    else if (window.location.hash.trim().length > 0) {
      this.stateChange('', window.location.hash.replace("#", ''))
    }
  }
  deletePlayer = () => {
    const { pokerwatchTeamBody } = this.state;
    let newAccountNames = [];
    if (pokerwatchTeamBody['playerData']) {
      newAccountNames.push(pokerwatchTeamBody['playerData']['playerName'])
    }
    else if (pokerwatchTeamBody['selectedData'] && pokerwatchTeamBody['selectedData'].length > 0) {
      newAccountNames = pokerwatchTeamBody['selectedData'].map((item, key) => item.playerName)
    }
    let obj = {
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name ? this.state.teamData.name : '',
      subTeamName: pokerwatchTeamBody['currentSubTeam'],
      newAccountName: newAccountNames
    }
    this.setState({
      pokerwatchTeamBody,
      loading: true
    })

    apiService(baseUrl + '/pokerwatch/deletePlayerFromTheTeam',
      obj,
      (res) => {
        pokerwatchTeamBody['statsUpdate'] = false
        pokerwatchTeamBody['selectedData'] = [];
        this.setState({
          pokerwatchTeamBody,
          loading: false
        })
        this.cancelDialog('onSuccess', '');
        if (window.location.hash !== '') {
          this.routeChange('/pokerwatchteam')

        }
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['currentSubTeam']);
      }
      , (err) => {
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })

  }
  getCallSubTeamList = () => {
    apiService(baseUrl + '/pokerWatch/getAllSubTeamList',
      {
        name: (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '',
        subTeam: 'default'
      }
      ,
      (data) => {
        const { pokerwatchTeamBody } = this.state
        pokerwatchTeamBody['subTeam'] = data;
        this.setState({
          pokerwatchTeamBody,
        })
      }, (err) => {
        console.log(err);
      })
  }
  switchTeam = (event) => {
    this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, event.target.value);
    let track = {}
    track.hit_page = 'Team';
    track.hit_type = 'StableClickTeam';
    track.hit_attribute1 = (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '';
    track.hit_attribute2 = event.target.value;
    saveActivity(track);
    const { pokerwatchTeamBody } = this.state
    let filterStatusObj = this.getFilterStatusUpdateObj('Teams', event.target.value !== 'all' ? event.target.value : "Show All Team", pokerwatchTeamBody['filterStatusObj']);
    pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
    pokerwatchTeamBody['startIndex'] = 0;
    pokerwatchTeamBody['showResults'] = true,
      this.setState({
        startIndex: 0,
        pokerwatchTeamBody
      })
  }
  handleAssignTeam = (event) => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['updatedSubTeam'] = event.target.value;
    this.setState({
      pokerwatchTeamBody
    })
    this.verifyRequiredParamsForDialog()
  }
  assignOrUpdatePlayerToTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    let newAccountNames = [];
    let playerData = pokerwatchTeamBody['selectedData'] && pokerwatchTeamBody['selectedData'].length > 0 ? pokerwatchTeamBody['selectedData']
      : pokerwatchTeamBody['playerData'] ? [pokerwatchTeamBody['playerData']] : []
    if (playerData && playerData.length > 0) {
      newAccountNames = playerData.map((item, key) => item.playerName)
    }

    let obj = {
      teamName: (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '',
      subTeamName: pokerwatchTeamBody['updatedSubTeam'],
      currentSubTeam: pokerwatchTeamBody['currentSubTeam'],
      'selectedPlayers': newAccountNames
    }
    apiService(baseUrl + '/pokerWatch/updatePlayerToSubTeam',
      obj,
      (res) => {
        this.setState({
          loading: false
        })
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['currentSubTeam']);
        this.cancelDialog('onSuccess', '');
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'updatePlayerError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })
  }
  reportCard = () => {
    if (this.state.moreEnable) {
      this.setState({
        moreEnable: false,
        gameDetails: false
      })
    }

    let track = {}
    track.hit_page = 'TeamDetail';
    track.hit_type = 'TeamPlayerViewReportCard';
    track.hit_attribute1 = (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '';
    track.hit_attribute2 = this.state.pokerwatchTeamBody.currentSubTeam && this.state.pokerwatchTeamBody.currentSubTeam != "" ? this.state.pokerwatchTeamBody.currentSubTeam : "All Teams";
    track.hit_attribute3 = this.state.playerData ? this.state.playerData.playerName : "N/A";
    saveActivity(track);

    window.open('/SkillLevel?accountName='
      + this.state.playerData.playerName + '&fromDate=' + this.state.selectedFromDate.format("YYYY-MM-DD HH:mm:ss") +
      '&fromTime=' + this.state.selectedFromDate.format("HH:mm:ss") + '&logintype=admin&shift=Select&toDate=' + this.state.selectedToDate.format("YYYY-MM-DD HH:mm:ss") +
      '&toTime=' + this.state.selectedToDate.format("HH:mm:ss"), '_blank');
  }
  callDateApi = () => {
    this.callPlayerStats(this.state.startIndex, this.state.max,
      this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
      this.state.sortOn, this.state.gameType)
    this.callApi(this.state.currentSubTeam, [this.state.pokerwatchTeamBody['playerData'].playerName], this.state.startIndex,
      this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
      this.state.gameType, this.state.playerActivity, this.state.sortOn);

  }
  handleReplayer = (e, item) => {
    let m = moment(item.time).utcOffset(0);
    m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    m.toISOString();
    let data = {
      gameNo: item.gameNo,
      gameType: item.gameType,
      partitionDate: m.format("YYYY-MM-DD HH:mm:ss"),
      playerName: this.state.pokerwatchTeamBody['playerData'].playerName,
      players_alias: this.state.pokerwatchTeamBody['playerData'].playerName,
      selectedFromDate: this.state.selectedFromDate,
      selectedToDate: this.state.selectedToDate
    };

    let track = {}
    track.hit_page = 'TeamDetail';
    track.hit_type = 'TeamPlayerReplayHand';
    track.hit_attribute1 = (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '';
    track.hit_attribute2 = this.state.pokerwatchTeamBody.currentSubTeam && this.state.pokerwatchTeamBody.currentSubTeam != "" ? this.state.pokerwatchTeamBody.currentSubTeam : "All Teams";
    track.hit_attribute3 = data.playerName;
    track.hit_attribute4 = data.gameNo;
    saveActivity(track);

    localStorage.setItem('handleReplayerData', JSON.stringify(data));
    window.open('/pokerwatchreplayer', '_blank');
    this.setState({
      gameDetails: false
    })
  }
  updateSubTeamName = () => {
    const { pokerwatchTeamBody } = this.state;
    const { creatTeamObj } = pokerwatchTeamBody;
    creatTeamObj['currentSubTeam'] = pokerwatchTeamBody['currentSubTeam'];
    this.setState({
      loading: true
    })

    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'EditTeam';
    track.hit_attribute1 = creatTeamObj.teamName;
    track.hit_attribute2 = creatTeamObj.subTeamName;
    saveActivity(track);

    apiService(baseUrl + '/pokerWatch/updateSubTeamName',
      creatTeamObj,
      (res) => {

        this.setState({
          loading: false
        })
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['creatTeamObj'].subTeamName);
        this.cancelDialog();
      }
      , (err) => {

        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })


      })
  }
  filterPlayerNames = (event) => {
    const { pokerwatchTeamBody } = this.state;

    pokerwatchTeamBody['filterPlayerList'] = pokerwatchTeamBody['playerNames'].filter(player => player.toLowerCase().includes(event.target.value.toLowerCase()));
    this.setState({
      pokerwatchTeamBody
    })

  }
  getPlayerNamesByTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    let obj = {
      'teamName': this.state.teamData.teamName,
    }
    apiService(baseUrl + '/pokerWatch/getPlayerNamesByTeam',
      obj,
      (res) => {
        if (res) {
          pokerwatchTeamBody['playerNames'] = res.players;
          pokerwatchTeamBody['filterPlayerList'] = res.players;
        }
        else {
          pokerwatchTeamBody['playerNames'] = []
          pokerwatchTeamBody['filterPlayerList'] = [];
        }
        this.setState({
          pokerwatchTeamBody
        })
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })
  }
  createSubTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    this.setState({
      loading: true
    })
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'CreateNewTeam';
    track.hit_attribute1 = pokerwatchTeamBody.creatTeamObj.teamName;
    track.hit_attribute2 = pokerwatchTeamBody.creatTeamObj.subTeamName;
    saveActivity(track);
    apiService(baseUrl + '/pokerWatch/createSubTeam',
      pokerwatchTeamBody['creatTeamObj'],
      (res) => {
        this.setState({
          loading: false
        })
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['creatTeamObj']['subTeamName']);
        this.cancelDialog('onSuccess', '')
        this.getCallSubTeamList();
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })

  }
  verifyRequiredParamsForDialog = (custom) => {
    const { pokerwatchTeamBody, dialogContent } = this.state;
    let type = custom ? custom : dialogContent['dataType'];
    let createTeamObj = pokerwatchTeamBody['creatTeamObj'];
    dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button-not-active'
    switch (type) {
      case 'custom':
        dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button-not-active'
        break;
      case 'addUser':
        if (pokerwatchTeamBody['players'] && pokerwatchTeamBody['players'].length > 0) {
          dialogContent['createButtonStyleName'] = 'poker-watch-new-button-active'
        }
        else {
          dialogContent['createButtonStyleName'] = 'poker-watch-new-button-not-active'
        }
        break;
      case 'addPlayer':
        if (pokerwatchTeamBody['selectedPlayers'] && pokerwatchTeamBody['selectedPlayers'].length > 0) {
          dialogContent['createButtonStyleName'] = 'poker-watch-new-button-active';
        }
        else {
          dialogContent['createButtonStyleName'] = 'poker-watch-new-button-not-active'
        }
        break;
      case 'coachCreationModal':
      case 'ownerCreationModal':
      case 'coachCreationModalUpdate':
        if (createTeamObj.fullName && createTeamObj.email && createTeamObj.password) {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
      case 'editTeam':
        if (createTeamObj.subTeamName && createTeamObj.teamName) {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
      case 'createNewTeam':
        if (createTeamObj.name && createTeamObj.subTeamName && createTeamObj.teamName) {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
      case 'changeCoach':
      case 'changeOwner':
        if (createTeamObj.name) {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
      case 'addPlayer':
        if (pokerwatchTeamBody['selectedPlayers'] && pokerwatchTeamBody['selectedPlayers'].length > 0) {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
      case 'assingPlayer':
        if (pokerwatchTeamBody['updatedSubTeam'] && pokerwatchTeamBody['updatedSubTeam'] !== '') {
          dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
        }
        break;
    }
    pokerwatchTeamBody['dialogContent'] = dialogContent;
    this.setState({
      pokerwatchTeamBody,
      dialogContent
    })

  }

  verifyCoachByNameOrUserName = (e, dataType) => {
    const { pokerwatchTeamBody } = this.state;
    let dialogBoxType = pokerwatchTeamBody['dialogContent']['dataType']
    pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...dataType.inputObj };
    if (!e.target.value || e.target.value.length < 2 || dataType.type == 'password') {
      if (dataType.type === 'password') {
        pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...dataType.inputObj };
      }
      pokerwatchTeamBody['teamNameData'] = [];
      pokerwatchTeamBody['coachDetails'] = [];
      if (dialogBoxType === 'changeCoach' || dialogBoxType === 'changeOwner' || dialogBoxType === 'createNewTeam') {
        this.verifyRequiredParamsForDialog('custom')
      }
      else {
        this.verifyRequiredParamsForDialog()
      }
      // console.log('pokerwatchConfigObjpokerwatchConfigObj', pokerwatchTeamBody);
      this.setState({
        pokerwatchTeamBody
      })
      return;
    }
    else {
      let query = dataType.inputObj;
      const endPoint = dataType.type === 'ownerDetails' ? '/pokerWatch/getOwnersList' : '/pokerWatch/getCoachByName';
      apiService(baseUrl + endPoint,
        query, (data) => {
          pokerwatchTeamBody['action'] = this.addInputObject;
          if (dialogBoxType === 'changeCoach' || dialogBoxType === 'changeOwner' || dialogBoxType === 'createNewTeam') {
            this.verifyRequiredParamsForDialog('custom')
          }
          else {
            this.verifyRequiredParamsForDialog()
          }
          pokerwatchTeamBody['errorOBj'] = { ...data }
          if (data && data.result.length > 0) {
            pokerwatchTeamBody['coachDetails'] = data.result;
          }
          else {
            pokerwatchTeamBody['coachDetails'] = [];
          }
          this.setState({
            pokerwatchTeamBody,
            loading: false,
          })
        }, (err) => {
          console.log(err);
        })
      this.setState({
        query,
        searchFunc: true
      })
    }

  }
  deleteSubTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    let obj = {
      teamName: (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '',
      subTeamName: pokerwatchTeamBody['currentSubTeam']
    }

    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'DeleteTeam';
    track.hit_attribute1 = obj.teamName;
    track.hit_attribute2 = obj.subTeamName;
    saveActivity(track);

    apiService(baseUrl + '/pokerWatch/deleteSubTeam',
      obj,
      (res) => {
        this.setState({
          loading: false
        })
        this.cancelDialog();
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true);
      }
      , (err) => {
        this.setState({ loading: false })
      })
  }
  addInputObject = (e, obj) => {
    const { pokerwatchTeamBody } = this.state
    pokerwatchTeamBody['coachDetails'] = [];
    pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...obj };
    this.setState({
      pokerwatchTeamBody
    })
    this.verifyRequiredParamsForDialog();
  }
  verifyUnique = (e, teamName) => {
    let creatTeamObj = {
      'subTeamName': e.target.value,
      'teamName': teamName
    };
    if (e.target.value && e.target.value.length < 2) {

      const { pokerwatchTeamBody } = this.state;
      pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...creatTeamObj };
      this.setState({
        pokerwatchTeamBody
      })
      this.verifyRequiredParamsForDialog()
      return;
    }
    else {
      const name = e.target.value;
      const endPoint = '/pokerWatch/verifyTeamName';
      apiService(baseUrl + endPoint,
        {
          name: teamName,
          subTeam: name,
          type: 'subTeam'

        }, (data) => {

          const { pokerwatchTeamBody, dialogContent } = this.state;
          dialogContent['errorMessage'] = '';
          pokerwatchTeamBody['isTeamAlreadyExist'] = false;
          dialogContent['isError'] = false;
          if (data.length > 0) {
            dialogContent['isError'] = true;
            pokerwatchTeamBody['dialogContent'] = dialogContent;
            pokerwatchTeamBody['isTeamAlreadyExist'] = true
          }

          pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...creatTeamObj };
          this.verifyRequiredParamsForDialog()
          this.setState({
            pokerwatchTeamBody
          })
        }, (err) => {
          console.log(err);
        })
    }

  }
  openDialogBox = (dataType, type, isMobileView) => {
    //  console.log('openDialogBox', dataType, type, isMobileView)
    let customStyle = {
      width: window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '38.5rem', top: window.innerWidth <= 1024 ? '-15%' : '-8%',
      left: window.innerWidth <= 320 ? '-2rem' : window.innerWidth <= 375 ? '0px' : window.innerWidth <= 425 ? '30px' : window.innerWidth <= 1024 ? '26%' : window.innerWidth <= 1440 ? '30%' : '36%', height: '10%'
    };
    const { pokerwatchTeamBody, dialogContent } = this.state;
    dialogContent['createButtonLable'] = 'Create';
    dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button-not-active';
    let componentName = pokerwatchTeamBody['activeComponentName'];
    dialogContent['isButtonsShow'] = true;
    dialogContent['newButton'] = false;
    if (isMobileView) {

      pokerwatchTeamBody[[componentName]] = false;
      pokerwatchTeamBody['lastComponentName'] = componentName;
    }
    pokerwatchTeamBody[[type]] = !this.state[type];
    const { cancelDialog } = pokerwatchTeamBody;
    dialogContent['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '39rem';
    dialogContent['padding'] = '0px 20px 20px 20px';
    if (dataType === 'addUser') {
      dialogContent['createButtonStyleName'] = 'poker-watch-new-button-not-active';
      dialogContent['padding'] = '0px 78px 20px 78px';
      dialogContent['title'] = window.innerWidth <= 1024 ? <h3 style={{
        marginLeft: window.innerWidth <= 325 ? '24%' : window.innerWidth <= 375 ? '28%' :
          window.innerWidth <= 425 ? '30%' :
            window.innerWidth < 768 ? '35%' : '40%'
      }}>{'Add User(s)'}</h3> : <h3>{'Add User(s)'}<i className="fa fa-times"
        onClick={e => cancelDialog(e, { dataType })}
        style={{ "color": '#8F8F8F', fontSize: '20px', float: 'right', marginTop: '-5px' }}></i></h3>

      dialogContent['actionPerform'] = this.addPlayerToTeam;
      dialogContent['objectType'] = 'team';
      dialogContent['createButtonLable'] = 'ADD';
      dialogContent['newButton'] = true;
      dialogContent['isButtonsShow'] = false;
      dialogContent['titleAlign'] = 'center';
      customStyle['minHeight'] = '80vh';
      customStyle['left'] = window.innerWidth <= 320 ? '-2rem' : window.innerWidth <= 375 ? '0px' : window.innerWidth <= 425 ? '30px' : window.innerWidth <= 1024 ? '26%' : window.innerWidth <= 1440 ? '25%' : '36%';
      customStyle['top'] = window.innerWidth <= 1024 ? '-15%' : '-2%'
      customStyle['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '58.8rem';
      customStyle['height'] = '53rem';
      dialogContent['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '58.8rem';
      dialogContent['height'] = '53rem';
    }
    else if (dataType === 'coachCreationModal') {
      dialogContent['fromDialog'] = true;
      dialogContent['title'] = 'Create New Coach';
      dialogContent['createButtonLable'] = 'Create';
      dialogContent['dataType'] = 'coachCreationModal';
      dialogContent['objectType'] = 'coachCreationModal';
      dialogContent['actionPerform'] = this.createCoach;
    }
    else if (dataType === 'createNewTeam') {
      dialogContent['title'] = 'Create New Team';
      dialogContent['objectType'] = 'team';
      dialogContent['actionPerform'] = this.createSubTeam;
      dialogContent['createButtonLable'] = 'Create';
      pokerwatchTeamBody['errorOBj'] = {};
    }
    else if (dataType === 'changeOwner') {
      dialogContent['title'] = 'Change Stable Owner';
      dialogContent['objectType'] = 'team';
      dialogContent['actionPerform'] = this.updateOwnerForTeam;
      dialogContent['createButtonLable'] = 'Change';

    }
    else if (dataType === 'editTeam') {
      dialogContent['title'] = 'Edit Team Name';
      dialogContent['objectType'] = 'editTeamName';
      dialogContent['actionPerform'] = this.updateSubTeamName;
    }
    else if (dataType === 'changeCoach') {
      dialogContent['title'] = 'Change Coach';
      dialogContent['objectType'] = 'editTeamName';
      dialogContent['actionPerform'] = this.changeCoach;
      dialogContent['createButtonLable'] = 'Change';
    }
    else if (dataType === 'addPlayer') {
      customStyle['left'] = window.innerWidth <= 320 ? '-2rem' : window.innerWidth <= 375 ? '0px' : window.innerWidth <= 425 ? '30px' : window.innerWidth <= 1024 ? '26%' : window.innerWidth <= 1440 ? '25%' : '36%';
      customStyle['top'] = window.innerWidth <= 1024 ? '-15%' : '-2%'
      customStyle['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '42.5rem';
      customStyle['height'] = '53rem';
      dialogContent['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '58.8rem';
      dialogContent['height'] = '53rem';
      dialogContent['createButtonStyleName'] = 'poker-watch-new-button-not-active';
      dialogContent['padding'] = '0px 78px 20px 78px';
      dialogContent['title'] = window.innerWidth <= 1024 ? <h3> {'Add Stable User(s) to the Team'}</h3> :
        <h3>{'Add Stable User(s) to the Team'}<i className="fa fa-times"
          onClick={e => cancelDialog(e, { dataType })}
          style={{ "color": '#8F8F8F', fontSize: '20px', float: 'right', marginTop: '-5px' }}></i></h3>
      dialogContent['objectType'] = 'addPlayers';
      dialogContent['titleAlign'] = 'center';
      dialogContent['fontWeight'] = 'normal';
      dialogContent['actionPerform'] = this.addPlayerToSubTeam;
      this.getPlayerNamesByTeam();
      dialogContent['createButtonLable'] = 'ADD';
      dialogContent['newButton'] = true;
      dialogContent['isButtonsShow'] = false;
      customStyle['padding'] = '0px 20px 20px';
    }
    else if (dataType === 'deleteTeam') {
      dialogContent['title'] = 'Delete Team';
      dialogContent['objectType'] = 'editTeamName';
      dialogContent['actionPerform'] = this.deleteSubTeam;
      dialogContent['createButtonLable'] = 'Delete';
      dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
    }
    else if (dataType === 'deletePlayer') {
      dialogContent['title'] = 'Remove Player(s)';
      dialogContent['objectType'] = 'deletePlayer';
      dialogContent['actionPerform'] = this.deletePlayer;
      dialogContent['createButtonLable'] = 'Remove';
      dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
      dialogContent['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.9rem' : '37rem' : '51.1rem';
    }
    else if (dataType === 'assingPlayer') {
      dialogContent['title'] = 'Assign selected player(s)';
      dialogContent['objectType'] = 'assingPlayer';
      dialogContent['actionPerform'] = this.assignOrUpdatePlayerToTeam;
      dialogContent['createButtonLable'] = 'Assign';
      pokerwatchTeamBody['updatedSubTeam'] = '';
    }
    else if (dataType === 'enableStats' || dataType === 'disableStats') {
      dialogContent['title'] = 'Are you sure ?';
      dialogContent['objectType'] = 'enableStats';
      dialogContent['width'] = window.innerWidth <= 1024 ? window.innerWidth <= 768 ? '28.8rem' : '37rem' : '51.1rem';
      dialogContent['createButtonLable'] = 'Yes';
      dialogContent['actionPerform'] = dataType === 'enableStats' ? this.updatePlayerStatsToON : this.updatePlayerStatsToOFF;
      dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button'
    }
    dialogContent['fontSize'] = '25px';
    dialogContent['borderRadius'] = '5x';
    dialogContent['height'] = '37rem';
    dialogContent['dataType'] = dataType;
    dialogContent['errorMessage'] = '';
    dialogContent['customStyle'] = customStyle;
    dialogContent['cancelDialog'] = this.cancelDialog;
    dialogContent['isDialogOpen'] = true;
    pokerwatchTeamBody['dialogContent'] = dialogContent;
    pokerwatchTeamBody['players'] = [];
    this.setState({
      [componentName]: (isMobileView && this.state[componentName] ? true : false),
      pokerwatchTeamBody,
      dialogContent,
      [type]: !this.state[type]
    })
  }

  getEvDollor = (item) => {
    if (isNaN(item.winRate) || isNaN(item.ev)) {
      return 0;
    }
    let evDollor = this.NumberFormatter(item.profitOrLoss - item.ev);
    return evDollor;
  }

  NumberFormatter = (num) => {
    if (isNaN(num)) {
      return 0;
    }
    if (Math.abs(num) > 999 && Math.abs(num) <= 999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + ' K'
    }
    else if (Math.abs(num) > 999999 && Math.abs(num) <= 999999999) {
      return Math.trunc(Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1))) + ' M'
    }
    else if (Math.abs(num) > 999999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + 'B'
    }
    else {
      return Number(Math.sign(num) * Math.abs(num).toFixed(2));
    }

  }

  trackDownloadPlayerHandHistory = (PlayerName) => {

    let track = {}
    track.hit_page = 'TeamDetail';
    track.hit_type = 'TeamPlayerDownloadHandhistory';
    track.hit_attribute1 = (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '';
    track.hit_attribute2 = this.state.pokerwatchTeamBody.currentSubTeam && this.state.pokerwatchTeamBody.currentSubTeam != "" ? this.state.pokerwatchTeamBody.currentSubTeam : "All Teams";;
    track.hit_attribute3 = PlayerName;
    saveActivity(track);
  }

  componentWillUnmount() {
    closeVirtualPage()

  }
  addPlayerToList = (e, r) => {
    const { pokerwatchTeamBody } = this.state;
    let players = pokerwatchTeamBody['players'] !== undefined ? pokerwatchTeamBody['players'] : []
    const index = players.indexOf(r);
    if (index > -1) {
      players.splice(index, 1);
    } else {
      players.push(r);
    }
    pokerwatchTeamBody['players'] = players;
    pokerwatchTeamBody['playerNameData'] = [];
    this.setState({
      pokerwatchTeamBody
    })
    this.verifyRequiredParamsForDialog();
  }

  routeChange = (data) => {
    let path = data ? data : '/pokerwatch';
    this.props.history.push(path);
  }
  refreshPage = () => {
    this.callApi(this.state.currentSubTeam, [this.state.playerName], this.state.startIndex,
      this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
      this.state.gameType, this.state.playerActivity, this.state.sortOn);
  }


  stateChange = (event, playerData) => {
    const { pokerwatchTeamBody } = this.state
    if (pokerwatchTeamBody['playerData'] != null && playerData === pokerwatchTeamBody['playerData'].playerName
    ) {
      return ''
    }
    pokerwatchTeamBody['selectedData'] = [playerData]
    pokerwatchTeamBody['playerNameDataByTeam'] = [];
    this.setState({
      playerNameDataByTeam: [],

    })
    if (playerData) {
      if (playerData.playerName !== undefined) {
        pokerwatchTeamBody['playerData'] = playerData
        this.setState({
          pokerwatchTeamBody,
          playerData: playerData,
          deletePlyrData: []
        });
      }
      else {
        this.callApi(this.state.currentSubTeam, [playerData], this.state.startIndex,
          this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
          this.state.gameType, this.state.playerActivity, this.state.sortOn);
        let obj = {
          "_id": 1,
          noOfGames: 0,
          startStack: 0,
          endStackStack: 0,
          totalRake: 0,
          lastHandPlayer: '',
          profitOrLoss: 0,
          playerName: playerData,
          count: 0,
          accountName: playerData
        }
        this.setState({
          playerData: obj,
          deletePlyrData: []
        })
      }
      if (this.state.teamData.ownerName !== null && (playerData == this.state.teamData.ownerName
        || playerData.playerName == this.state.teamData.ownerName)) {
        this.setState({
          roleValue: 'teamOwner'
        })
      }
      else {
        this.setState({
          roleValue: 'player'
        })
      }
    }
    if (this.state.teamTableStatus || window.location.hash.trim().length > 0) {
      let filterStatusObj = this.getEnabledCurrentFilter(['Game Type', 'From', 'To'], pokerwatchTeamBody['filterStatusObj'])
      pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
      this.props.setHeaderTitle('Pokerwatch-Player')
      let appendData = playerData.playerName ? playerData.playerName : playerData;

      let track = {}
      track.hit_page = 'TeamDetail';
      track.hit_type = 'TeamPlayerDetail';
      track.hit_attribute1 = (this.state.teamData !== undefined && this.state.teamData.name !== undefined) ? this.state.teamData.name : this.state.teamData.teamName ? this.state.teamData.teamName : '';
      track.hit_attribute2 = this.state.pokerwatchTeamBody.currentSubTeam && this.state.pokerwatchTeamBody.currentSubTeam != "" ? this.state.pokerwatchTeamBody.currentSubTeam : "All Teams";
      track.hit_attribute3 = appendData;
      saveActivity(track);
      localStorage.setItem('accountNames', JSON.stringify([appendData]));
      if (window.location.hash == '') {
        pokerwatchTeamBody['filterEnable'] = false;
        pokerwatchTeamBody['showFromDatePicker'] = false;
        pokerwatchTeamBody['showToDatePicker'] = false;
        this.setState({
          moreEnable: false,
          filterEnable: false,
          showFromDatePicker: false,
          showToDatePicker: false,
          pokerwatchTeamBody
        })
        let path = '/pokerwatchteam#' + appendData;

        this.props.history.push(path);
      }
      this.callPlayerStats(this.state.startIndex, this.state.max,
        this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
        this.state.sortOn, this.state.gameType)
      this.setState({
        teamTableStatus: false,
        deletePlyrData: []
      })

    }
    else {
      this.props.setHeaderTitle(this.state.title)
      let filterStatusObj = this.getEnabledCurrentFilter(['Game Type', 'Team', 'From', 'To', 'Player Activity'], pokerwatchTeamBody['filterStatusObj'])
      pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
      pokerwatchTeamBody['selectedData'] = [];
      pokerwatchTeamBody['playerData'] = [];
      pokerwatchTeamBody['filterEnable'] = false;
      pokerwatchTeamBody['moreEnable'] = false;
      pokerwatchTeamBody['showFromDatePicker'] = false;
      pokerwatchTeamBody['showToDatePicker'] = false;
      this.setState({
        pokerwatchTeamBody,
        showFromDatePicker: false,
        showToDatePicker: false,
        filterEnable: false, moreEnable: false, teamTableStatus: true
      });
    }
  }
  getEnabledCurrentFilter = (type, filterStatusObj) => {
    filterStatusObj = filterStatusObj.map((item, key) => {
      item.showView = type.includes(item.key) ? true : false;
      return item;
    })
    return filterStatusObj;
  }
  callPlayerStats = (startIndex, max, orderBy, selectedFromDate, selectedToDate, sortOn, playerGameType, isCallNext) => {
    this.setState({
      loading: true
    })
    const { pokerwatchTeamBody } = this.state;
    let inputRequest = {
      startDate: selectedFromDate.format("YYYY-MM-DD HH:mm:ss"),
      endDate: selectedToDate.format("YYYY-MM-DD HH:mm:ss"),
      startIndex: this.state.showFromDatePicker ? 0 : startIndex,
      max: max,
      orderBy: orderBy,
      playerName: this.state.pokerwatchTeamBody['playerData'].playerName,
      teamName: this.state.teamData.name ? this.state.teamData.name : this.state.teamData.teamName,
      gameType: playerGameType,
      sortOn: sortOn,
      offset: this.state.offset
    }

    apiService(baseUrl + '/pokerWatch/getPlayerDetailsByTeamAndById',
      inputRequest,
      (data) => {
        if (!(startIndex !== 0 && data.length == 0)) {
          pokerwatchTeamBody['selectedData'] = [];
          let playerStats = data.map((item, key) => {

            let cards = [];
            {
              item.dealtToCards.forEach((element, index) => {
                cards.push(<img width="15.5px" height="20.5px" className="card_images" src={imgUrl + 'cards/' + element + '.png'} key={index} alt={element} />)
              })
            }
            item['stakeLevel'] = item.gameType == 'cash' ? ('$' + item.stakeLevel.small + '/' + "$" + item.stakeLevel.big) : (item.stakeLevel.small + '/' + item.stakeLevel.big);
            item['dealtToCards'] = cards;
            item['replayer'] = <i className="fa fa-lg fa-play-circle user-play-circle"></i>
            return item
          })

          pokerwatchTeamBody['playerStats'] = isCallNext && pokerwatchTeamBody['playerStats'] ? pokerwatchTeamBody['playerStats'].concat(playerStats) : playerStats
          if (!isCallNext) {
            pokerwatchTeamBody['isPlayerStatsAvailable'] = true;
          }
          if (playerStats && playerStats.length < this.state.max) {
            pokerwatchTeamBody['isPlayerStatsAvailable'] = false;
          }
          this.setState({
            pokerwatchTeamBody,
            loading: false,
            data: data,
            nextLoading: data.length < this.state.max ? false : true,
            showFromDatePicker: false,
            showToDatePicker: false
          })
        }
        else {
          pokerwatchTeamBody['isPlayerStatsAvailable'] = false;
          this.setState({
            pokerwatchTeamBody,
            loading: false,
            nextLoading: false,
            showFromDatePicker: false,
            showToDatePicker: false
          })
        }
      }, (err) => {
        pokerwatchTeamBody['isPlayerStatsAvailable'] = false;
        this.setState({
          pokerwatchTeamBody,
          loading: false,
          error: "No Data Found"
        })
        console.log(err);
      })
  }

  handleChange = (data, dateType) => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody[[dateType]] = data;
    if (dateType !== 'gameDetails') {
      this.setState({
        gameDetails: false
      })
    }
    this.setState({
      [dateType]: data,
      pokerwatchTeamBody
    })
  }
  handleSave = (dateType, dataPicker, type) => {
    let errorStatus = false;
    let { dateError } = this.state

    if (this.state.selectedFromDate.isAfter(this.state.selectedToDate)) {
      errorStatus = true;
      dateError = { 'fromDate': "*Should not be greater than To-Date." }

    } else if (this.state.selectedFromDate.isAfter(moment())) {
      errorStatus = true;
      dateError = { 'fromDate': "*Should not be greater than current time." };

    } else if (this.state.selectedToDate.isAfter(moment())) {
      errorStatus = true;
      dateError = { "toDate": "*Should not be greater than current time." }

    } else if (this.state.selectedFromDate.isBefore(moment().subtract(2, 'days'))) {
      errorStatus = true;
      dateError = { "fromDate": "*Should be within last 48 hours" }

    } else if (this.state.selectedToDate.isBefore(moment().subtract(2, 'days'))) {
      errorStatus = true;
      dateError = { "toDate": "*Should be in last 48 hours." }

    } else {
      errorStatus = false;
      dateError = ""

    }
    const { pokerwatchTeamBody } = this.state
    pokerwatchTeamBody['dateError']=dateError;
    pokerwatchTeamBody[[dateType]] = (dateType === "downloadFrom") ? this.state.selectedFromDate : this.state.selectedToDate

    if (!errorStatus && (pokerwatchTeamBody['showFromDatePicker'] || pokerwatchTeamBody['showToDatePicker'])) {
      pokerwatchTeamBody['filterEnable'] = type !== 'cleared' ? true : this.state.filterEnable;
      pokerwatchTeamBody['showResults'] = true,
        this.setState({
          filterEnable: type !== 'cleared' ? true : this.state.filterEnable,
          loading: true,
          startIndex: 0,
          teamFeedSettings: false
        })
      if (type !== 'cleared') {
        let filterStatusObj = this.getFilterStatusUpdateObj('From', this.state.selectedFromDate.format("DD/MM/YYYY - hh:mmA"), pokerwatchTeamBody['filterStatusObj'], type);
        filterStatusObj = this.getFilterStatusUpdateObj('To', this.state.selectedToDate.format("DD/MM/YYYY - hh:mmA"), filterStatusObj, type)
        pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
      }
      if (type === 'player') {
        this.callApi(this.state.currentSubTeam, [this.state.pokerwatchTeamBody['playerData'].playerName], 0,
          this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
          this.state.gameType, this.state.playerActivity, this.state.sortOn);
      }
      else {
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, false, pokerwatchTeamBody['currentSubTeam']);
        this.callApi(this.state.currentSubTeam, [], 0,
          this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
          this.state.gameType, this.state.playerActivity, this.state.sortOn);
      }
    }
    pokerwatchTeamBody[[dataPicker]] = true
    console.log('pokerwatchTeamBody in handle save', pokerwatchTeamBody)
    this.setState({
      pokerwatchTeamBody,
      dateError,
      [dateType]: (dateType === "downloadFrom") ? this.state.selectedFromDate : this.state.selectedToDate,
    })
  }
  handleTime = (event) => {
    let value = event.target.value;
    this.setState({ value: event.target.value });
    this.setState({ timeValue: value });
    let selectedTime = moment().subtract(value.substring(0, value.indexOf(" ")), value.substring(value.indexOf("") + 3));
    this.setState({ selectedFromDate: selectedTime });
    this.setState({ selectedToDate: moment() });
    this.setState({
      loading: true,
      startIndex: 0
    })

    this.callApi([this.state.playerName], 0,
      this.state.max, this.state.orderBy, selectedTime, moment(), this.state.gameType, this.state.playerActivity, this.state.sortOn);
  }
  getFilterStatusUpdateObj = (type, value, filterStatusObj, clear) => {
    filterStatusObj = filterStatusObj.map((item, key) => {
      // console.log("type", type, "key", item.key, "itemvalue", item.value, "value", value, "passedValue")
      if (item.key === type) {
        if (clear && clear === 'clearFromDate' && type === "From") {
          item.value = value;
          item.defaultValue = value;
          item.visible = false;
          item.passedValue = moment().subtract(2, 'days')
        }
        else if (clear && clear === 'clearToDate' && type === "To") {
          item.value = value;
          item.defaultValue = value;
          item.visible = false;
          item.passedValue = moment();

        }
        else if (value !== item.value || item.value !== item.defaultValue) {
          item.value = value;
          item.visible = item.value === item.defaultValue ? false : true;
        }
      }
      return item;
    })
    return filterStatusObj;
  }
  handlePlayerActivity = (event) => {
    let value = event.target.value;
    const { pokerwatchTeamBody } = this.state;
    let filterStatusObj = this.getFilterStatusUpdateObj('Player Activity', value == 0 ? 'Not Played' : value == 1 ? 'Played' : 'All', pokerwatchTeamBody['filterStatusObj']);
    pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
    pokerwatchTeamBody['playerActivity'] = value;
    pokerwatchTeamBody['filterEnable'] = this.state.filterEnable
    pokerwatchTeamBody['showResults'] = true,
      this.setState({
        filterEnable: this.state.filterEnable,
        pokerwatchTeamBody,
        playerActivity: value,
        startIndex: 0,
        teamFeedSettings: false
      })

    if (value == 0) {
      let teamDummyData = {
        "_id": null,
        "noOfGames": 0,
        "startStack": 0,
        "endStackStack": 0,
        "totalRake": 0,
        "lastHandPlayer": '',
        "profitOrLoss": 0,
        "name": this.state.teamData.name || this.state.teamData.teamName,
        "noOfPlayers": 0,
        "ownerName": this.state.teamData.ownerName,
        "ev": "ev"
      }
      this.setState({
        teamData: teamDummyData
      })
    } else {
      this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, false, pokerwatchTeamBody['currentSubTeam']);
    }
    this.callApi(this.state.currentSubTeam, [this.state.playerName], 0,
      this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
      this.state.gameType, value, this.state.sortOn);
  }
  handleGameType = (event, type) => {
    let value = event.target.value;
    const { pokerwatchTeamBody } = this.state;
    let filterStatusObj = this.getFilterStatusUpdateObj('Game Type', value === 'cash' ? 'Cash Games' : value === 'tournament' ? 'MTT' : 'Spins', pokerwatchTeamBody['filterStatusObj']);
    pokerwatchTeamBody['filterStatusObj'] = filterStatusObj;
    pokerwatchTeamBody['gameType'] = value;
    pokerwatchTeamBody['filterEnable'] = true
    pokerwatchTeamBody['showResults'] = true,
      this.setState({
        filterEnable: true,
        pokerwatchTeamBody,
        gameType: value,
        startIndex: 0,
        teamFeedSettings: false
      })
    if (type && type === 'player') {
      this.callPlayerStats(this.state.startIndex, this.state.max,
        this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
        this.state.sortOn, value)

      this.callApi(this.state.currentSubTeam, [this.state.pokerwatchTeamBody['playerData'].playerName], 0,
        this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
        value, this.state.playerActivity, this.state.sortOn);
    }
    else {
      this.callTeamList(value, this.state.selectedFromDate, this.state.selectedToDate, false, pokerwatchTeamBody['currentSubTeam']);
      this.callApi(this.state.currentSubTeam, [this.state.pokerwatchTeamBody['playerData'] ? this.state.pokerwatchTeamBody['playerData'].playerName : ''], 0,
        this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
        value, this.state.playerActivity, this.state.sortOn);
    }

  }

  handlePlayer = () => {
    this.setState({
      loading: true,
      startIndex: 0
    })
    this.callApi(this.state.currentSubTeam, [this.state.playerName], 0,
      this.state.max, this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
      this.state.gameType, this.state.playerActivity, this.state.sortOn);
  }

  playerSort = (event, dataType) => {

    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['sortOn'] = dataType;
    pokerwatchTeamBody['sortOrder'] = pokerwatchTeamBody['sortOrder'] ? pokerwatchTeamBody['sortOrder'] === 'desc' ? 'asc' : 'desc' : 'asc';
    this.callPlayerStats(pokerwatchTeamBody['playerStartIndex'], this.state.max,
      pokerwatchTeamBody['sortOrder'], this.state.selectedFromDate, this.state.selectedToDate,
      dataType === 'lastHandPlayer' ? 'time' : dataType, this.state.playerGameType)
    pokerwatchTeamBody['playerStartIndex'] = 0;
    this.setState({
      pokerwatchTeamBody,
      startIndex: 0,
      sortOn: dataType,
      loading: true,
    })
  }
  sorting = (event, dataType) => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['showResults'] = true;
    let playerData = []
    if (window.location.hash !== '' && pokerwatchTeamBody['playerData'] && pokerwatchTeamBody['playerData']['playerName']) {
      playerData.push(pokerwatchTeamBody['playerData']['playerName'])
    }
    pokerwatchTeamBody['sortOn'] = dataType;
    this.setState({
      orderBy: this.state.orderBy == 'desc' ? 'asc' : 'desc',
      startIndex: 0,
      sortOn: dataType,
      loading: true,
    })
    this.callApi(this.state.currentSubTeam, playerData, 0, this.state.max, this.state.orderBy == 'desc' ? 'asc' : 'desc',
      this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, dataType === 'lastHandPlayer' ? 'time' : dataType);

  }
  openCreateModal = () => {
    this.setState({
      createPlayerModal: !this.state.createPlayerModal,
      moreEnable: false
    })
  }
  openStatsModal = (event, data) => {
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'StatsOnOff';
    track.hit_attribute1 = this.state.teamData.teamName;
    track.hit_attribute4 = data;
    saveActivity(track);
    this.setState({
      statsUpdateModal: !this.state.statsUpdateModal,
      statusButtonStatus: !this.state.statusButtonStatus,
      onOff: data,
      moreEnable: false
    })
  }
  openDeleteModal = () => {
    if (this.state.deletePlyrData.length > 0) {
      this.setState({
        deletePlayerModal: true,
        moreEnable: false
      })
    }
  }

  callApiService = (endPoint, data) => {
    this.setState({
      loading: true
    })
    apiService(baseUrl + endPoint,
      data,
      (res) => {
        if (endPoint !== '/pokerwatch/getFileListByTeam') {
          let playerArray = []
          if (window.location.hash.trim().length > 0) {
            playerArray = [window.location.hash.replace("#", '')]
          }
          else {
            playerArray = this.state.playerName && this.state.playerName !== '' ? [this.state.playerName] : []
          }
          this.callApi(this.state.currentSubTeam, playerArray, this.state.pokerwatchTeamBody['startIndex'] ? this.state.pokerwatchTeamBody['startIndex'] : this.state.startIndex, this.state.max, this.state.orderBy,
            this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, this.state.sortOn);

          this.cancelDialog('onSuccess', '')

        }
        else {

          this.setState({
            fileDetailsList: res,
            loading: false,
          })
        }
        if (this.state.createPlayerModal) {
          this.setState({
            createPlayerModal: false
          })
        }

      }, (err) => {

        if (endPoint == '/pokerwatch/addPlayerToTheTeam') {
          const { pokerwatchTeamBody, dialogContent } = this.state;
          dialogContent['errorMessage'] = err.responseJSON.err
          dialogContent['isError'] = true;
          pokerwatchTeamBody['dialogContent'] = dialogContent;
          this.setState({ pokerwatchTeamBody })
        }
        this.setState({
          loading: false
        })
      })
  }
  addPlayerToTeam = () => {

    const { pokerwatchTeamBody } = this.state
    let accountNames = pokerwatchTeamBody['players'];
    if (accountNames && accountNames.length > 0) {
      let track = {}
      track.hit_page = 'Team';
      track.hit_type = 'AssignUser';
      track.hit_attribute1 = this.state.teamData.teamName;
      track.hit_attribute2 = typeof accountNames === "string" ? accountNames : accountNames.join(',');
      saveActivity(track);
      let data = {
        teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name ? this.state.teamData.name : '',
        accountNames: accountNames
      }
      this.callApiService("/pokerwatch/addPlayerToTheTeam", data)
    }
    else {
      this.setState({
        playerErrorMsg: "Please give the account name"
      })
    }
  }

  cancelDialog = (event, modal) => {

    const { pokerwatchTeamBody } = this.state;
    const { dialogContent } = pokerwatchTeamBody || {}
    if (modal && modal.dataType === 'coachCreationModal' && !dialogContent.fromDialog) {
      dialogContent['title'] = 'Create New Team';
      dialogContent['objectType'] = 'team';
      dialogContent['dataType'] = 'createNewTeam';
      dialogContent['createButtonLable'] = 'Create';
      dialogContent['actionPerform'] = this.createSubTeam;
      pokerwatchTeamBody['dialogContent'] = dialogContent;
      this.setState({
        pokerwatchTeamBody
      })
    }
    else if (modal && modal.dataType === 'coachCreationModalUpdate') {
      dialogContent['title'] = 'Change Coach';
      dialogContent['createButtonLable'] = 'Change';
      dialogContent['objectType'] = 'team';
      dialogContent['dataType'] = 'changeCoach';
      dialogContent['actionPerform'] = this.changeCoach;
      pokerwatchTeamBody['dialogContent'] = dialogContent;
      this.setState({
        pokerwatchTeamBody
      })
    }
    else if (modal && modal.dataType === 'ownerCreationModal') {
      dialogContent['title'] = 'Change Owner';
      dialogContent['objectType'] = 'team';
      dialogContent['createButtonLable'] = 'Change';
      dialogContent['dataType'] = 'changeOwner';
      dialogContent['actionPerform'] = this.updateOwnerForTeam;
      pokerwatchTeamBody['dialogContent'] = dialogContent;
      this.setState({
        pokerwatchTeamBody
      })
    }
    else {
      dialogContent['isDialogOpen'] = false;
      pokerwatchTeamBody['creatTeamObj'] = {};
      pokerwatchTeamBody['dialogContent'] = dialogContent;
      pokerwatchTeamBody['selectedPlayers'] = [];
      pokerwatchTeamBody['showStatus'] = false;
      pokerwatchTeamBody['playerNameData'] = [];
      let lastComponentName = pokerwatchTeamBody['lastComponentName'];
      if (window.innerWidth <= 1024 && event !== 'onSuccess'
        && ((lastComponentName === 'subMenuEnable' && !(dialogContent.dataType === 'deleteTeam')) || (lastComponentName === 'moreEnable'
          || lastComponentName === 'playerMenuEnable'))) {

        pokerwatchTeamBody[[lastComponentName]] = true;
        this.setState({
          [lastComponentName]: true,
          [[modal]]: false,
          pokerwatchTeamBody,
          dialogContent
        })

      }
      else {
        this.setState({
          [lastComponentName]: false,
          [[modal]]: false,
          pokerwatchTeamBody,
          dialogContent
        })
      }
    }
    if (modal == 'fileListModal') {
      this.setState({
        uploadedFileList: null,
        uploadingFileList: []
      })
    }

  }
  addPlayerToSubTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    this.setState({
      loading: true
    })
    let obj = {
      'role': 'coach',
      'teamName': this.state.teamData.teamName,
      'subTeamName': pokerwatchTeamBody['currentSubTeam'],
      'selectedPlayers': pokerwatchTeamBody['selectedPlayers']
    }

    let track = {}
    track.hit_page = 'Team';
    track.hit_type = 'AssignUser';
    track.hit_attribute1 = obj.teamName;
    track.hit_attribute2 = obj.subTeamName;
    track.hit_attribute3 = typeof obj.selectedPlayers === "string" ? obj.selectedPlayers : obj.selectedPlayers.join(',');
    saveActivity(track);

    apiService(baseUrl + '/pokerWatch/addPlayerToSubTeam',
      obj,
      (res) => {
        this.setState({
          loading: false
        })
        this.cancelDialog();
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['currentSubTeam']);
      }
      , (err) => {

        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })
  }
  changeCoach = () => {
    const { pokerwatchTeamBody } = this.state;
    this.setState({
      loading: true
    })

    let obj = {
      'role': 'coach',
      'teamName': this.state.teamData.teamName,
      'subTeamName': pokerwatchTeamBody['currentSubTeam']
    }

    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'ChangeTeamCoach';
    track.hit_attribute1 = obj.teamName;
    track.hit_attribute2 = obj.subTeamName;
    saveActivity(track);

    pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...obj };

    apiService(baseUrl + '/pokerWatch/updateCoachOrOwner',
      pokerwatchTeamBody['creatTeamObj'],
      (res) => {

        this.setState({
          loading: false
        })

        this.cancelDialog();
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['currentSubTeam']);
      }
      , (err) => {

        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })


      })

  }
  updateOwnerForTeam = () => {
    const { pokerwatchTeamBody } = this.state;
    this.setState({
      loading: true
    })
    let obj = {
      'role': 'owner',
      'teamName': this.state.teamData.teamName
    }
    pokerwatchTeamBody['creatTeamObj'] = { ...pokerwatchTeamBody['creatTeamObj'], ...obj };

    apiService(baseUrl + '/pokerWatch/updateCoachOrOwner',
      pokerwatchTeamBody['creatTeamObj'],
      (res) => {
        this.setState({
          loading: false
        })
        this.cancelDialog();
        this.callTeamList(this.state.gameType, this.state.selectedFromDate, this.state.selectedToDate, true, pokerwatchTeamBody['currentSubTeam']);
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createTeamError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })

  }
  handleSelectPlayer = (status, item) => {
    console.log('handleSelectPlayer', item)
    const { pokerwatchTeamBody } = this.state
    let selectedPlayers = pokerwatchTeamBody['selectedPlayers'] ? pokerwatchTeamBody['selectedPlayers'] : [];
    if (!status) {
      selectedPlayers.push(item);
      pokerwatchTeamBody['selectedPlayers'] = selectedPlayers;
      this.setState({
        pokerwatchTeamBody
      })
    }
    else {
      selectedPlayers.splice(selectedPlayers.indexOf(item), 1);
      pokerwatchTeamBody['selectedPlayers'] = selectedPlayers;
      this.setState({
        pokerwatchTeamBody
      })

    }
    this.verifyRequiredParamsForDialog('addPlayer')
  }
  handleCheck = (seletedData) => {
    const { pokerwatchTeamBody } = this.state
    pokerwatchTeamBody['selectedData'] = seletedData
    this.setState({
      pokerwatchTeamBody
    })
    let newAccountName = [];
    if (seletedData) {
      newAccountName = seletedData.map((item, key) => item.playerName)
    }

    localStorage.setItem('accountNames', JSON.stringify(newAccountName));
  }
  handleCheckbox = (event, item) => {
    const { pokerwatchTeamBody } = this.state;
    let selectedData = pokerwatchTeamBody['selectedData'] ? pokerwatchTeamBody['selectedData'] : [];
    const index = selectedData.indexOf(item);
    if (index > -1) {
      selectedData.splice(index, 1);
    } else {
      selectedData.push(item);
    }
    pokerwatchTeamBody['selectedData'] = selectedData;
    this.setState({
      pokerwatchTeamBody
    })

  }

  deletePlayerList = () => {
    let newAccountName = [];
    if (this.state.pokerwatchTeamBody['selectedData']) {
      newAccountName = this.state.pokerwatchTeamBody['selectedData'].map((item, key) => item.playerName)
    }
    this.setState({
      teamTableStatus: true,
      deletePlayerModal: false,
    })
    let data = {
      newAccountName,
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name,
      deletePlyrData: []
    }
    this.callApiService('/pokerwatch/deletePlayerFromTheTeam', data);
  }
  openDownloadModal = () => {
    this.setState({
      downloadModal: !this.state.downloadModal,
    })
  }
  openFileListModal = () => {
    this.setState({
      fileListModal: true,
    })
    let data = {
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name
    }
    this.callApiService('/pokerwatch/getFileListByTeam', data)

  }
  roleUpdateModal = () => {
    this.setState({
      roleChangedModal: !this.state.roleChangedModal,
    })
  }

  createOwner = () => {
    const { pokerwatchTeamBody } = this.state
    this.setState({
      loading: true
    })
    apiService(baseUrl + '/pokerWatch/createOwner',
      pokerwatchTeamBody['creatTeamObj'],
      (res) => {
        this.setState({
          loading: false
        })
        let modal = {
          'dataType': 'ownerCreationModal'
        };
        this.cancelDialog('', modal);
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createOwnerError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })
  }
  createCoach = () => {
    const { pokerwatchTeamBody } = this.state
    this.setState({
      loading: true
    })
    apiService(baseUrl + '/pokerWatch/createCoach',
      pokerwatchTeamBody['creatTeamObj'],
      (res) => {
        this.setState({
          loading: false
        })
        let modal = {
          'dataType': pokerwatchTeamBody['dialogContent'].dataType
        };

        this.cancelDialog('', modal);
      }
      , (err) => {
        const { pokerwatchTeamBody } = this.state;
        pokerwatchTeamBody['errorOBj'] = { 'createCoachError': err.responseJSON.err }
        this.setState({ pokerwatchTeamBody, loading: false })
      })
  }
  updateObject = (data) => {
    const { pokerwatchTeamBody, dialogContent } = this.state
    dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button-not-active'
    if (data === 'owner') {
      dialogContent['title'] = 'Create New Owner';
      pokerwatchTeamBody['type'] = 'ownerDetails';
      dialogContent['createButtonLable'] = 'Create';
      dialogContent['dataType'] = 'ownerCreationModal';
      dialogContent['objectType'] = 'ownerCreationModal';
      dialogContent['actionPerform'] = this.createOwner;
    }
    else if (data === 'coachUpdate') {
      pokerwatchTeamBody['type'] = '';
      dialogContent['createButtonLable'] = 'Create';
      dialogContent['title'] = 'Create New Coach';
      dialogContent['dataType'] = 'coachCreationModalUpdate';
      dialogContent['objectType'] = 'coachCreationModalUpdate';
      dialogContent['actionPerform'] = this.createCoach;
    }
    else {
      pokerwatchTeamBody['type'] = '';
      dialogContent['fromDialog'] = false;
      dialogContent['title'] = 'Create New Coach';
      dialogContent['createButtonLable'] = 'Create';
      dialogContent['dataType'] = 'coachCreationModal';
      dialogContent['objectType'] = 'coachCreationModal';
      dialogContent['actionPerform'] = this.createCoach;
    }

    pokerwatchTeamBody['dialogContent'] = dialogContent;
    this.setState({
      pokerwatchTeamBody
    })
  }
  getPlayerDetailsByTeamNameAndName = (event) => {
    let inputData = event.target.value;
    if (event.target.value.length > 2) {
      this.setState({
        query: event.target.value,
        searchFunc: true
      }, () => {

        this.setState({
          loading: true
        })
        apiService(baseUrl + '/pokerwatch/getPlayerDetailsByNameAndTeam',
          {
            newAccountName: inputData,
            teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name
          },
          (data) => {
            if (data !== '') {
              const { pokerwatchTeamBody } = this.state;
              pokerwatchTeamBody['playerNameDataByTeam'] = data;
              this.setState({
                pokerwatchTeamBody, playerNameDataByTeam: data
              });
            }
            else {

              this.setState({
                playerNameDataByTeam: []
              })
            }
          }, (err) => {
            console.log(err);
          })
        this.setState({
          loading: false
        })
      })
    }
    else {
      const { pokerwatchTeamBody } = this.state;
      pokerwatchTeamBody['playerNameDataByTeam'] = [];
      this.setState({
        pokerwatchTeamBody, playerNameDataByTeam: []
      });
    }
  }
  getPlayerDetailsByName = (event) => {
    let value = event.target.value;
    if (value.length > 2) {
      this.setState({
        query: value,
        searchFunc: true
      }, () => {

        this.setState({
          loading: true
        })
        apiService(baseUrl + '/pokerwatch/getPlayerDetailsByName',
          {
            newAccountName: value
          },
          (data) => {
            const { pokerwatchTeamBody, dialogContent } = this.state;
            dialogContent['errorMessage'] = '';
            dialogContent['isError'] = false;
            pokerwatchTeamBody['playerNameData'] = data;
            pokerwatchTeamBody['dialogContent'] = dialogContent;
            this.setState({
              pokerwatchTeamBody
            })

          }, (err) => {
            console.log(err);
          })
        this.setState({
          loading: false,
          playerErrorMsg: ''
        })
      })
    }


  }
  deleteFileList = (event, item) => {
    let fileList = this.state.uploadingFileList;
    fileList.splice(fileList.indexOf(item), 1);
    this.setState({
      uploadingFileList: fileList
    })

  }
  onChangeHandler = (event) => {
    this.setState({
      maxSelectFileStatus: this.maxSelectFile(event),
      memeTypeStatus: this.checkMimeType(event),
      fileUploadErrorMessage: ''
    })
    if (this.maxSelectFile(event) && this.checkMimeType(event)) {
      this.setState({
        uploadedFile: event.target.files[0]
      })
      this.setState({
        uploadedFileList: event.target.files,
        uploadingFileList: [...this.state.uploadingFileList, ...event.target.files]
      })
      // console.log("event.target.files",event.target.files.length)
      this.onClickHandler(event.target.files);
    }

  }
  onClickHandler = (uploadedFileList) => {
    console.log('file upload', uploadedFileList.length)
    if (uploadedFileList !== null && uploadedFileList.length > 0) {

      this.setState({
        uploading: true
      })
      //let data = new FormData()
      const data = new FormData()
      data.append('teamName', this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name)
      for (var x = 0; x < uploadedFileList.length; x++) {
        data.append('files', uploadedFileList[x])
      }

      fetch(baseUrl + '/pokerwatch/upload', {
        method: 'POST',
        body: data,
        headers: {
          'x-access-token': localStorage.getItem('token')
        }
      }).then((response) => {
        let data = {
          teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name
        }
        if (response.status == 409) {
          this.setState({
            fileUploadErrorMessage: 'You cannot upload same file again'
          })
        }
        this.callApiService('/pokerwatch/getFileListByTeam', data)
        this.setState({
          uploadingFileList: [],
          uploadedFileList: [],
          uploading: false
        })
      }).catch(() => {
        this.setState({
          uploading: false
        })
      })
    }
  }
  getPlayerDetailsByTeamNameAndNameWithDetails = (players) => {
    if (players !== '') {
      this.callApi(this.state.currentSubTeam, players, this.state.startIndex, this.state.max, this.state.orderBy,
        this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, this.state.sortOn);
    }
    this.setState({
      playerNameDataByTeam: [],
      teamFeedSettings: false
    })

  }
  searchPlayerDetailsOnEnter = (event, players) => {

    if (event.key === 'Enter' && players !== '') {
      const { pokerwatchTeamBody } = this.state;
      pokerwatchTeamBody['filterEnable'] = false;
      this.setState({
        pokerwatchTeamBody,
        filterEnable: false,
        teamFeedSettings: false
      })
      this.callApi(this.state.currentSubTeam, players, this.state.startIndex, this.state.max, this.state.orderBy,
        this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, this.state.sortOn);
    }
    this.setState({
      playerNameDataByTeam: []
    })

  }
  callNext = (type) => {
    const { pokerwatchTeamBody } = this.state;
    if (type && type === 'player') {
      let playerData = pokerwatchTeamBody['playerStats'];
      let max = this.state.max;
      if (playerData.length >= max) {
        let startIndex = pokerwatchTeamBody['playerStartIndex'];
        startIndex = startIndex + max;
        pokerwatchTeamBody['playerStartIndex'] = startIndex;
        this.setState({
          pokerwatchTeamBody,
        })
        this.callPlayerStats(startIndex, this.state.max,
          this.state.orderBy, this.state.selectedFromDate, this.state.selectedToDate,
          this.state.sortOn, this.state.playerGameType, true)
      }
    } else {
      let playerData = pokerwatchTeamBody['teamTableData'];
      let max = this.state.max;
      if (playerData.length >= max) {
        let startIndex = pokerwatchTeamBody['startIndex'];
        startIndex = startIndex + max;
        pokerwatchTeamBody['startIndex'] = startIndex;
        this.setState({
          pokerwatchTeamBody,
        })
        this.callApi(this.state.currentSubTeam, null, startIndex, max, this.state.orderBy,
          this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, this.state.sortOn, true);
      }
    }
  }
  callPrevious = () => {
    if (this.state.startIndex !== 0) {
      this.setState({
        startIndex: this.state.startIndex > this.state.max ? this.state.startIndex - this.state.max : 0,
        nextLoading: true
      })
      this.callApi(this.state.currentSubTeam, null, this.state.startIndex > this.state.max ? this.state.startIndex - this.state.max : 0, this.state.max, this.state.orderBy,
        this.state.selectedFromDate, this.state.selectedToDate, this.state.gameType, this.state.playerActivity, this.state.sortOn);
    }
  }
  maxSelectFile = (event) => {
    let files = event.target.files // create file object
    if (files.length > 10) {
      const msg = 'Only 10 images can be uploaded at a time'
      event.target.value = null // discard selected file
      return false;
    }
    return true;
  }
  checkMimeType = (event) => {
    //getting file object
    let files = event.target.files
    //define message container
    let err = ''
    // list allow mime type
    const types = ['text/csv']
    // loop access array
    for (var x = 0; x < files.length; x++) {
      // compare file type find doesn't matach
      if (types.every(type => files[x].type !== type)) {
        // create error message and assign to container   
        err += files[x].type + ' is not a supported format\n';
      }
    };
    if (err !== '') { // if message not same old that mean has error 
      event.target.value = null // discard selected file
      console.log(err)
      return false;
    }
    return true;

  }

  deleteFile = (event, fName) => {
    this.setState({
      loading: true,
      fileUploadErrorMessage: ''
    })
    let data = {
      fileName: fName,
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name
    }
    apiService(baseUrl + '/pokerwatch/delete',
      data,
      (res) => {
        if (res !== null) {
          let fileData = {
            teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name
          }
          this.callApiService('/pokerwatch/getFileListByTeam', fileData)
        }
        this.setState({
          loading: false
        })
      }, (err) => {
        this.setState({
          loading: false
        })
      })
  }
  downloadFile = (event, fileName) => {
    fetch(baseUrl + '/pokerwatch/download', {
      method: 'POST',
      body: JSON.stringify({ fileName: fileName, teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name }),
      headers: {
        'x-access-token': localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName.replace(this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name + '/', '');
        a.click();
      });
    })
  }
  updatePlayerStatsToON = (event, data) => {
    const { pokerwatchTeamBody } = this.state;
    let newAccountNames = [];
    if (pokerwatchTeamBody['playerData']) {
      newAccountNames.push(pokerwatchTeamBody['playerData'].playerName)
    }
    else if (pokerwatchTeamBody['selectedData'] && pokerwatchTeamBody['selectedData'].length > 0) {
      newAccountNames = pokerwatchTeamBody['selectedData'].map((item, key) => item.playerName)
    }
    let postData = {
      newAccountName: newAccountNames,
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name ? this.state.teamData.name : '',
      statsStatus: true
    }
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'StatsOnOff';
    track.hit_attribute1 = postData.teamName;
    track.hit_attribute4 = "on";
    saveActivity(track);
    pokerwatchTeamBody['startIndex'] = 0;
    this.setState({
      pokerwatchTeamBody
    })
    this.callApiService('/pokerwatch/updateStatSettings', postData);
  }
  updatePlayerStatsToOFF = (event, data) => {
    const { pokerwatchTeamBody } = this.state;
    let newAccountNames = [];
    if (pokerwatchTeamBody['playerData']) {
      newAccountNames.push(pokerwatchTeamBody['playerData'].playerName)
    }
    else if (pokerwatchTeamBody['selectedData'] && pokerwatchTeamBody['selectedData'].length > 0) {
      newAccountNames = pokerwatchTeamBody['selectedData'].map((item, key) => item.playerName)
    }
    let postData = {
      newAccountName: newAccountNames,
      teamName: this.state.teamData && this.state.teamData.teamName ? this.state.teamData.teamName : this.state.teamData.name ? this.state.teamData.name : '',
      statsStatus: false
    }
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'StatsOnOff';
    track.hit_attribute1 = postData.teamName;
    track.hit_attribute4 = "off";
    saveActivity(track);
    pokerwatchTeamBody['startIndex'] = 0;
    this.setState({
      pokerwatchTeamBody
    })
    this.callApiService('/pokerwatch/updateStatSettings', postData);
  }
  selectPlayer = (accountName) => {
    this.playerSearch.value = accountName;
    this.setState({
      newAccountName: accountName,
      playerNameData: []
    })
  }
  enableComponent = (type, activeComp, status) => {
    const { pokerwatchTeamBody } = this.state;
    pokerwatchTeamBody['showResults'] = false;
    let activeComponentName = pokerwatchTeamBody['activeComponentName'];
    if (type && type !== '') {
      if (!activeComp) {
        pokerwatchTeamBody[[activeComponentName]] = false;
      }
      pokerwatchTeamBody[[type]] = status ? status : !this.state[type];
      pokerwatchTeamBody['activeComponentName'] = type;
      this.setState({
        pokerwatchTeamBody,
        [activeComponentName]: !activeComp ? false : true,
        [type]: status ? status : !this.state[type]
      })
    }
    else {
      pokerwatchTeamBody['onClickTriggered'] = true;
      if (activeComponentName !== 'filterEnable') {
        pokerwatchTeamBody[[activeComponentName]] = false;
      }
      pokerwatchTeamBody['activeComponentName'] = 'filterEnable';
      this.setState({
        pokerwatchTeamBody,
        [activeComponentName]: false
      })
    }
  }
  enableOrDisableTeadFeedSettings = () => {
    this.setState({
      teamFeedSettings: true,
      moreEnable: false
    })
  }
  componentWillMount() {
    this.props.setHeaderTitle(this.state.title);
  }
  enableFileProps = (item, key) => {
    const { pokerwatchTeamBody } = this.state;
    const enableProps = pokerwatchTeamBody.enableProps || {};
    console.log('enableProps', enableProps)
    enableProps['row'] = item;
    enableProps['key'] = key;
    enableProps['status'] = !enableProps['status'];
    pokerwatchTeamBody['enableProps'] = enableProps;
    this.setState({
      pokerwatchTeamBody
    })

  }
  render() {
    console.log('this.state.pokerwatchTeamBody', this.state);
    const { pokerwatchTeamBody } = this.state;
    const { enableProps } = pokerwatchTeamBody;
    let customStyle = {
      width: window.innerWidth <= 1024 ? '288px' : '385px', top: window.innerWidth <= 1024 ? '-15%' : '0%',
      left: window.innerWidth <= 320 ? '-20px' : window.innerWidth <= 375 ? '0px' : window.innerWidth <= 425 ? '30px' : window.innerWidth <= 768 ? '26%' : window.innerWidth <= 1024 ? '20%' : window.innerWidth <= 1440 ? '30%' : '38%', height: '10%'
    };

    
    return (
      <div>
        {this.state.fileListModal ? <MediaQuery minWidth={1025}>
          {(matches) => {
            if (matches) {
              return (<Dialog title={<h3>{'Files'}<i className="fa fa-times"
                onClick={e => this.cancelDialog(e, 'fileListModal')}
                style={{ "color": '#000000', fontSize: '14px', float: 'right', marginTop: '10px', marginRight: '10px' }}></i></h3>}
                titleStyle={{
                  fontSize: '25px',
                  backgroundColor: "white", color: "black", width: '511px', maxHeight: '296px', textAlign: 'left', fontWeight: "bold"
                  , padding: '10px 10px 4px 22px'
                }}
                modal={false} open={this.state.fileListModal}
                bodyStyle={{ backgroundColor: "white", width: '511px', height: '296px', maxHeight: '296px' }}
                contentStyle={{ backgroundColor: "white" }}
                style={customStyle}
                onRequestClose={e => this.cancelDialog(e, 'fileListModal')}
              >
                {(this.state.fileDetailsList && this.state.fileDetailsList.length > 0) || (this.state.uploadedFileList && this.state.uploadedFileList.length > 0) ?
               <FileUploadDetails
               memeTypeStatus = {this.state.memeTypeStatus}
               uploadingFileList = {this.state.uploadingFileList} 
               uploading = {this.state.uploading}
               deleteFile={this.deleteFile}
               fileUploadErrorMessage={this.state.fileUploadErrorMessage}
               maxSelectFileStatus = {this.state.maxSelectFileStatus}
               downloadFile = {this.downloadFile}
               fileDetailsList = {this.state.fileDetailsList}
               uploadedFileList={this.state.uploadedFileList}
                 enableProps = {enableProps}
                 enableFileProps = {this.enableFileProps}
                 onChangeHandler = {this.onChangeHandler}/>: <FileUploadComponent onChangeHandler={this.onChangeHandler} />}

              </Dialog >)
            }
            else {
              return '';
            }
          }}</MediaQuery> : ''}
        <div className="container pokerwatch-team-body" style={{ backgroundColor: 'white' }}>
          {this.state.loginRedirect && (<Redirect to={'/'} />)}
          {this.state.loading ? <Loading backgroundColor={'transparent'} /> : null}
          {!this.state.teamTableStatus ? <PokerwatchPlayerBody {...this.state.pokerwatchTeamBody} trackDownloadPlayerHandHistory={this.trackDownloadPlayerHandHistory} ></PokerwatchPlayerBody>
            : <PokerwatchTeamBody {...this.state.pokerwatchTeamBody}></PokerwatchTeamBody>}
        </div>
        <DownloadHandHistory />
      </div>);
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle))
  }
};
export default connect(null, mapDispatchToProps)(withRouter(PokerWatchTeam));


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/PokerWatchTeam.js
 **/